import * as React from 'react'
import styled from 'styled-components'

import * as entities from '@owl-nest/entities'
import * as ds from '@bob/design-system'
import { styles as S } from '@bob/design-system'

import { PillarAccordion } from './PillarAccordion'

type RationaleProps = {
  environmentalPillars: entities.tag.MediumTag<entities.tag.ExtraPillar>[]
  rationale?: string | null
  socialPillars: entities.tag.MediumTag<entities.tag.ExtraPillar>[]
  title: string
}

export function Rationale({
  environmentalPillars,
  rationale,
  socialPillars,
  title,
}: RationaleProps): React.ReactElement {
  return (
    <Section>
      <S.heading.Title3 as="h3">{title}</S.heading.Title3>
      {rationale && <S.copy.Text1 as="p">{rationale}</S.copy.Text1>}
      {environmentalPillars.length > 0 && (
        <PillarAccordion
          brush={ds.color.LIGHT_GREEN}
          criteria={environmentalPillars.map((criterion) => ({
            description: criterion.pillar.description,
            icon: criterion.pillar.icon,
            name: criterion.name,
            slug: criterion.slug,
          }))}
          pillar="Environnementaux"
        />
      )}
      {socialPillars.length > 0 && (
        <PillarAccordion
          brush={ds.color.YELLOW}
          criteria={socialPillars.map((criterion) => ({
            description: criterion.pillar.description,
            icon: criterion.pillar.icon,
            name: criterion.name,
            slug: criterion.slug,
          }))}
          pillar="Sociaux"
        />
      )}
    </Section>
  )
}

const Section = styled.section`
  background-color: ${ds.color.SAND_2};
  margin: 0px -20px;
  padding: 30px 20px;
  margin-bottom: 40px;
  margin-top: 40px;

  @media screen and (${ds.breakpoint.MOBILE_L}) {
    margin-right: -40px;
    padding-right: 40px;
    margin-left: -40px;
    padding-left: 40px;
  }
  @media screen and (${ds.breakpoint.LAPTOP}) {
    margin-right: -90px;
    padding-right: 90px;
    margin-left: -90px;
    padding-left: 90px;
  }
  @media screen and (${ds.breakpoint.LAPTOP_L}) {
    margin-right: -140px;
    padding-right: 140px;
    margin-left: -140px;
    padding-left: 140px;
  }

  ${S.heading.Title3} {
    margin: 0 0 20px;
  }
`
